import React from 'react'
import { AgTechTourConfig } from './AgTechTourTypes'
import { useAgTechTour } from './AgTechTourContext'

type AgTechTourHelpButtonProps = {
    tourConfig: AgTechTourConfig
    classes?: string
}

const AgTechTourHelpButton = ({ tourConfig, classes }: AgTechTourHelpButtonProps) => {
    const { startTour } = useAgTechTour()

    return (
        <div
            className={`cursor-pointer text-detail hover:text-highlight transition-colors ${classes ?? ''}`}
            onClick={() => startTour(tourConfig)}
            title='Start Tour'
        >
            <i className="bi bi-question-circle text-lg" />
        </div>
    )
}

export default AgTechTourHelpButton
